import { c as _c } from "react/compiler-runtime";
import type { OrganizationRole, TenantRoleKindDiscriminant } from '@onefootprint/request-types/dashboard';
import { Table } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import useRolesQueryParams from '../hooks/use-roles-query-params';
import Row from './components/row';
type RolesTableProps = {
  data?: OrganizationRole[];
  errorMessage?: string;
  isPending?: boolean;
  kind: TenantRoleKindDiscriminant;
  /** Whether to render the search box. Off for the (non-paginated) auditor-roles section. */
  searchable?: boolean;
};
const RolesTable = t0 => {
  const $ = _c(17);
  const {
    data,
    errorMessage,
    isPending,
    kind,
    searchable: t1
  } = t0;
  const searchable = t1 === undefined ? true : t1;
  const {
    t
  } = useTranslation("roles");
  const queryParams = useRolesQueryParams();
  const isMobile = useMobileLayout();
  let t2;
  if ($[0] !== isMobile || $[1] !== kind || $[2] !== t) {
    t2 = isMobile ? [{
      id: "role",
      text: t(_temp),
      width: "100%"
    }, {
      id: "actions",
      text: "",
      width: "64px"
    }] : [{
      id: "role",
      text: t(_temp2),
      width: "19%"
    }, kind === "api_key" ? {
      id: "active-api-keys",
      text: t(_temp3),
      width: "12%"
    } : {
      id: "active-users",
      text: t(_temp4),
      width: "12%"
    }, {
      id: "permissions",
      text: t(_temp5),
      width: "37%"
    }, {
      id: "created",
      text: t(_temp6),
      width: "15%"
    }, {
      id: "actions",
      text: "",
      width: "5%"
    }];
    $[0] = isMobile;
    $[1] = kind;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const columns = t2;
  let t3;
  if ($[4] !== queryParams) {
    t3 = search => {
      queryParams.push({
        rolesSearch: search,
        rolesPage: undefined
      });
    };
    $[4] = queryParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSearchChange = t3;
  let t4;
  if ($[6] !== columns || $[7] !== data || $[8] !== errorMessage || $[9] !== handleSearchChange || $[10] !== isMobile || $[11] !== isPending || $[12] !== queryParams.isReady || $[13] !== queryParams.values || $[14] !== searchable || $[15] !== t) {
    t4 = queryParams.isReady ? <Table aria-label={t(_temp7)} columns={columns} emptyStateText={errorMessage || t(_temp8)} getKeyForRow={_temp9} hideThead={isMobile} initialSearch={searchable ? queryParams.values.search : undefined} isLoading={isPending} items={data} onChangeSearchText={searchable ? handleSearchChange : undefined} renderTr={t5 => {
      const {
        item: role_0
      } = t5;
      return <Row role={role_0} isMobile={isMobile} />;
    }} /> : null;
    $[6] = columns;
    $[7] = data;
    $[8] = errorMessage;
    $[9] = handleSearchChange;
    $[10] = isMobile;
    $[11] = isPending;
    $[12] = queryParams.isReady;
    $[13] = queryParams.values;
    $[14] = searchable;
    $[15] = t;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
export default RolesTable;
function _temp($) {
  return $.table.header.role;
}
function _temp2($_0) {
  return $_0.table.header.role;
}
function _temp3($_1) {
  return $_1.table.header.activeApiKeys;
}
function _temp4($_2) {
  return $_2.table.header.activeUsers;
}
function _temp5($_3) {
  return $_3.table.header.permissions;
}
function _temp6($_4) {
  return $_4.table.header.created;
}
function _temp7($_5) {
  return $_5.table.ariaLabel;
}
function _temp8($_6) {
  return $_6.table.emptyState;
}
function _temp9(role) {
  return role.id;
}